import {
  Box,
  Typography,
  ImageList,
  ImageListItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import bg from "../assets/images/about-us-2.png";
import img1 from "../assets/images/Opening.jpeg";
import img2 from "../assets/images/Openingceremoneyimgtkstrust.jpeg";
import img3 from "../assets/images/Openingceremonytkstrust.jpeg";
import img4 from "../assets/images/g1.jpeg";
import img5 from "../assets/images/g2.jpeg";
import img6 from "../assets/images/g3.jpeg";
import img7 from "../assets/images/g4.jpeg";
import img8 from "../assets/images/g5.jpeg";
import Slider1 from "../assets/images/Sirkazhi_Temple_2.jpeg";
import Slider2 from "../assets/images/Slider-images-TSCT1.jpg";
import Slider3 from "../assets/images/Thirukadaiyur-Temple1-TKSTrust.jpg";
import Slider4 from "../assets/images/cwa temple croped.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const images = [Slider1, Slider2, Slider3, Slider4];

const itemData = [
  { img: img1, title: "Opening 1" },
  { img: img2, title: "Opening 2" },
  { img: img3, title: "Opening 3" },
  { img: img4, title: "Gallery 1" },
  { img: img5, title: "Gallery 2" },
  { img: img6, title: "Gallery 3" },
  { img: img7, title: "Gallery 4" },
  { img: img8, title: "Gallery 5" },
];

function App() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const cols = isMobile ? 1 : isTablet ? 2 : 4;

  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          backgroundImage: `url(${bg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center top",
          height: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.4)",
            zIndex: 0,
          }}
        />
        <Box sx={{ zIndex: 1, px: 2 }}>
          <Typography
            sx={{
              fontWeight: "bold",
              color: "#FFCC03",
              fontSize: {
                xs: "2rem",
                sm: "2.5rem",
                md: "3rem",
                lg: "3.5rem",
                xl: "4rem",
              },
            }}
          >
            Gallery
          </Typography>
          <Typography
            sx={{
              fontWeight: "bold",
              mt: 2,
              color: "#fff",
              fontSize: {
                xs: "1.2rem",
                sm: "1.5rem",
                md: "1.75rem",
                lg: "2rem",
              },
            }}
          >
            Capturing our journey, milestones, and achievements.
          </Typography>
        </Box>
      </Box>

      {/* Opening Ceremony Section */}
      <Box sx={{ backgroundColor: "#f8f9e9", py: 6, textAlign: "center" }}>
        <Typography
          sx={{
            fontWeight: "bold",
            color: "#E52029",
            fontSize: {
              xs: "1.8rem",
              sm: "2rem",
              md: "2.25rem",
            },
          }}
        >
          Opening <span style={{ color: "#FAD707" }}>Ceremony</span>
        </Typography>
        <Typography
          sx={{
            mt: 2,
            color: "#000",
            lineHeight: 1.8,
            fontWeight: 600,
            fontSize: {
              xs: "0.95rem",
              sm: "1rem",
              md: "1.1rem",
            },
            px: { xs: 2, sm: 6, md: 12 },
          }}
        >
          Highlights from Thirukadaiyur Senaithalaivar Charitable Trust <br />
          Uniting Creativity, Celebrating Ceremony 🎨✨
        </Typography>
      </Box>

      {/* Image Grid Section */}
      <Box
        sx={{
          backgroundColor: "#f8f9e9",
          py: 4,
          px: { xs: 2, sm: 4, md: 6 },
          display: "flex",
          justifyContent: "center",
        }}
      >
        <ImageList
          sx={{ width: "100%", maxWidth: 1200 }}
          cols={cols}
          gap={10}
        >
          {itemData.map((item) => (
            <ImageListItem key={item.img}>
              <img
                src={item.img}
                alt={item.title}
                loading="lazy"
                style={{
                  borderRadius: "8px",
                  width: "100%",
                  height: "330px",
                  objectFit: "cover",
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>

      {/* Section Title for Slider */}
      <Box sx={{ backgroundColor: "#f8f9e9", py: 4, textAlign: "center" }}>
        <Typography
          sx={{
            fontWeight: "bold",
            color: "#E52029",
            fontSize: {
              xs: "1.8rem",
              sm: "2rem",
              md: "2.25rem",
            },
          }}
        >
          Photo <span style={{ color: "#FAD707" }}>Gallery</span>
        </Typography>
      </Box>

      {/* Swiper Image Slider */}
      <Box sx={{ backgroundColor: "#f8f9e9", py: 6, px: 2 }}>
        <Box sx={{ maxWidth: "1000px", margin: "0 auto", position: "relative" }}>
          <Swiper
            spaceBetween={20}
            slidesPerView={2}
            loop={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            navigation={{
              prevEl: ".custom-prev",
              nextEl: ".custom-next",
            }}
            modules={[Autoplay, Navigation]}
            breakpoints={{
              0: { slidesPerView: 1, spaceBetween: 10 },
              768: { slidesPerView: 2, spaceBetween: 20 },
            }}
          >
            {images.map((img, index) => (
              <SwiperSlide key={index}>
                <img
                  src={img}
                  alt={`Slider ${index + 1}`}
                  style={{
                    width: "100%",
                    height: "300px",
                    objectFit: "cover",
                    borderRadius: "10px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  }}
                />
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom Nav Buttons */}
          <button
            className="custom-prev"
            style={{
              position: "absolute",
              top: "50%",
              left: "-20px",
              transform: "translateY(-50%)",
              background: "transparent",
              color: "black",
              fontSize: "2rem",
              zIndex: 10,
              cursor: "pointer",
              border: "none",
            }}
            aria-label="Previous Slide"
          >
            ❮
          </button>

          <button
            className="custom-next"
            style={{
              position: "absolute",
              top: "50%",
              right: "-20px",
              transform: "translateY(-50%)",
              background: "transparent",
              color: "black",
              fontSize: "2rem",
              zIndex: 10,
              cursor: "pointer",
              border: "none",
            }}
            aria-label="Next Slide"
          >
            ❯
          </button>
        </Box>
      </Box>
    </Box>
  );
}

export default App;
